import { render } from "./ContactUs.vue?vue&type=template&id=0f2c2671&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=0f2c2671&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2c2671"]])

export default __exports__